import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  resetToken: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setResetToken(state, action) {
      state.resetToken = action.payload;
    },
  },
});

export const { setResetToken } = loginSlice.actions;
export default loginSlice.reducer;